// Teléfono de contacto de una publicación (autos, propiedades): el
// vendedor lo carga a mano en el formulario (`whatsapp`), en formato
// internacional, y se usa para el botón de WhatsApp y "Ver teléfono".
export const normalizePhone = (value) => String(value || "").replace(/[^\d+]/g, "");

export const isValidPhone = (value) => /^\+?\d{8,15}$/.test(normalizePhone(value));

export const whatsappUrl = (phone, text) => {
  const digits = normalizePhone(phone).replace(/^\+/, "");
  return `https://wa.me/${digits}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
};

export const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
